import React from "react";
import { useDispatch, batch } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import headset from "../../../../assets/images/headset.svg";

import { AmazonPollyPopup } from "./amazon-polly-popup"

import "./amazon-polly.m.css";

export const AmazonPolly = ({ story = {}, customClass = "" }) => {
  const dispatch = useDispatch();
  const storyDataKeys = ["slug", "summary", "headline", "access", "story-audio", ];
  const storyData = storyDataKeys.reduce((acc, key) => ({ ...acc, [key]: story[key] }), {});
  const audioS3Key = get(story, ["story-audio", "s3-key"], "");

  const onClickHandler = () => {
    batch(() => {
      dispatch({ type: "UPDATE_AMAZON_POLLY_DATA", payload: { storyData } });
      dispatch({ type: "OPEN_AMAZON_POLLY" });
    });
  };
  

  if (!audioS3Key) return null;

  return (
    <div styleName="amazon-polly-wrapper">
      <div
        styleName="amazon-polly-text-wrapper"
        className={customClass}
        onClick={onClickHandler}
      >
        <div styleName="amazon-polly-headset-wrapper">
          <img src={assetify(headset)} alt="amazone polly" className="amazon-polly-headset" /> 
        </div>
        <span styleName="amazon-polly-text">Listen to story</span>
      </div>
      <AmazonPollyPopup storyData={storyData}/>
    </div>
  );
};

AmazonPolly.propTypes = {
  story: PropTypes.object,
  customClass: PropTypes.string
};
